import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { IProfile } from "@/types/IProfile";
import { RootState } from "../store";

const initialState: IProfile = {
  id: 0,
  handle: "",
  profilePic: "",
  displayName: "",
  coverPic: "",
  socialLinkDiscord: "",
  socialLinkTelegram: "",
  socialLinkTwitter: "",
  socialLinkInstagram: "",
  followCheck: 0,
  bio: "",
  isInfluencer: false,
  isOutAdmin: 0,
  iAmBotBlocked: 0,
  dmAllowIncoming: 0,
  amountFollowers: 0,
  amountFollowing: 0,
  referralLinks: [],
  auth0id: "",
  twitterConnectionFound: 0,
  iBlockedThisProfile: 0,
  iMutedThisProfile: 0,
  refLink: "",
  userState: 0,
  trollName: "",
  trollColor: "",
  followsMe: 0,
  portfolioValue: 0,
  holdingCount: 0,
  holdersCount: 0,
  referralWallet: "",
  earnedFees: 0,
  bullbear: 0,
  wallets: [],
  myHoldingAmount: 0,
  iAmBlocked: 0,
  profileMerged: 0,
  postToTwitterDefault: 0,
  iAmTimedOut: 0,
  logRocketMonitoring: 0,
  homefeedSetting: 1,
  website: "",
  socialLinkWebsite: "",
  referralHandle: "",
  reflinkBlocked: 0,
  themeSetting: 1,
  walletsTotal: [],
  gccActivated: 0,
  isPredictorGoat: false,
  predictorScore: 0,
  predictorScore1d: 0,
  predictorScore7d: 0,
  predictorScore30d: 0,
  internalWallets: [],
};

// creating action-reducer slice
export const UserSlice = createSlice({
  name: "step_slice",
  initialState,
  reducers: {
    setProfile: (state, action: PayloadAction<IProfile>) => {
      if (action.payload) {
        state.bio = action.payload.bio;
        state.profilePic = action.payload.profilePic;
        state.coverPic = action.payload.coverPic;
        state.handle = action.payload.handle;
        state.amountFollowers = action.payload.amountFollowers;
        state.amountFollowing = action.payload.amountFollowing;
        state.socialLinkTwitter = action.payload.socialLinkTwitter;
        state.dmAllowIncoming = action.payload.dmAllowIncoming;
        state.id = action.payload.id;
        state.displayName = action.payload.displayName;
        state.socialLinkDiscord = action.payload.socialLinkDiscord;
        state.socialLinkTelegram = action.payload.socialLinkTelegram;
        state.isInfluencer = action.payload.isInfluencer;
        state.isOutAdmin = action.payload.isOutAdmin;
        state.iAmBotBlocked = action.payload.iAmBotBlocked;
        state.referralLinks = action.payload.referralLinks;
        state.auth0id = action.payload.auth0id;
        state.twitterConnectionFound = action.payload.twitterConnectionFound;
        state.iBlockedThisProfile = action.payload.iBlockedThisProfile;
        state.iMutedThisProfile = action.payload.iMutedThisProfile;
        state.refLink = action.payload.refLink;
        state.trollName = action.payload.trollName;
        state.trollColor = action.payload.trollColor;
        state.followsMe = action.payload.followsMe;
        state.wallets = action.payload.wallets;
        state.portfolioValue = action.payload.portfolioValue;
        state.holdersCount = action.payload.holdersCount;
        state.holdingCount = action.payload.holdingCount;
        state.referralWallet = action.payload.referralWallet;
        state.earnedFees = action.payload.earnedFees;
        state.bullbear = action.payload.bullbear;
        state.myHoldingAmount = action.payload.myHoldingAmount;
        state.iAmBlocked = action.payload.iAmBlocked;
        state.profileMerged = action.payload.profileMerged;
        state.postToTwitterDefault = action.payload.postToTwitterDefault;
        state.iAmTimedOut = action.payload.iAmTimedOut;
        state.logRocketMonitoring = action.payload.logRocketMonitoring;
        state.homefeedSetting = action.payload.homefeedSetting;
        state.socialLinkWebsite = action.payload.socialLinkWebsite;
        state.referralHandle = action.payload.referralHandle;
        state.reflinkBlocked = action.payload.reflinkBlocked;
        state.themeSetting = action.payload.themeSetting;
        state.walletsTotal = action.payload.walletsTotal;
        state.gccActivated = action.payload.gccActivated;
        state.internalWallets = action.payload.internalWallets
        //TODO-UNHIDE-CHAINS
          // .filter((wallet) => wallet.chain === "solana");
          .filter((wallet) =>
            // ["solana", "bsc", "base", "sonic", "ethereum"].includes(
            //   wallet.chain
            // )
            ["solana", "base"].includes(
              wallet.chain
            )
          )
          .sort((a, b) =>
            a.chain === "solana" ? -1 : b.chain === "solana" ? 1 : 0
          );
      }
    },
    setPostToTwitter: (
      state,
      action: PayloadAction<{ postToTwitter: number }>
    ) => {
      state.postToTwitterDefault = action.payload.postToTwitter;
    },
    setBullBear: (state, action: PayloadAction<{ bullbear: number }>) => {
      state.bullbear = action.payload.bullbear;
    },
    setHomeFeedSetting: (
      state,
      action: PayloadAction<{ homefeedSetting: number }>
    ) => {
      state.homefeedSetting = action.payload.homefeedSetting;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setProfile, setPostToTwitter, setBullBear, setHomeFeedSetting } =
  UserSlice.actions;

export const selectUser = (state: RootState) => state.user;

export default UserSlice.reducer;
